module.exports = __webpack_public_path__ + "img/200502.3eaf7770.png";